export const KUWAIT_PROVINCE_LOCATION = 'الكويت';
